import gql from 'graphql-tag';

export default gql`
  query GetProductionVisits($id: ID!) {
    getProductionVisits(id: $id) {
      lastYear
      thisYear
      sixMonths
      thirtyDays
      sevenDays
      today
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/ProductionVisits.js